import React from "react";
import { Box, Typography, Button } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";

interface BeginSurveyCardProps {
  title: string;
  buttonText: string;
  role: number | null | undefined;
  currentLanguage: string | null | undefined;
}

const BeginSurveyCard: React.FC<BeginSurveyCardProps> = ({
  title,
  buttonText,
  role,
  currentLanguage,
}) => {
const handleBeginSurvey = () => {
  const baseUrl = role === 1 
    ? 'https://www.research.net/r/VWVWGW2'
    : 'https://www.research.net/r/SDPJQJM';

  
  const langCode = currentLanguage || 'en';

  const surveyUrl = langCode === 'en' 
    ? `${baseUrl}?mid=[mid_value]`
    : `${baseUrl}?mid=[mid_value]&lang=${langCode}`;
  
  // Open survey in new tab
  window.open(surveyUrl, '_blank', 'noopener,noreferrer');
};

const handleClick = () => {
  handleBeginSurvey();
};

return (
  <Box
    sx={{
      mb: 2,
      p: { xs: 2, sm: 2.5, md: 3 },
      mx: "auto",
      width: "auto",
      // maxWidth: { xs: "95%", sm: "90%", md: "600px" },
      minWidth: { xs: "95%", sm: "90%", md: "600px" },
      background: " #ffffff",
      borderRadius: 3,
      border: "1px solid #e5e5e5",
      textAlign: "center",
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)",
      transition: "all 0.3s ease-in-out",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <Typography
      variant="h6"
      sx={{
        fontSize: { xs: "1.15rem", sm: "1.3rem", md: "1.4rem" },
        fontWeight: 700,
        color: "var(--color-text-primary)",
        mb: 2,
        lineHeight: 1.3,
      }}
    >
      {title}
    </Typography>
    <Button
     variant="text"
      onClick={handleClick}
      startIcon={<LinkIcon sx={{ fontSize: { xs: "18px", sm: "20px" }, transform: "rotate(-45deg)" }} />}
      sx={{
        textTransform: "none",
        fontSize: { xs: "0.95rem", sm: "1rem", md: "1.05rem" },
        fontWeight: 600,
        color: "var(--color-text-primary)",
        textDecoration: "underline",
        padding: 0,
        minWidth: 0,
        "&:hover": {
          textDecoration: "underline",
          backgroundColor: "transparent",
          color: "var(--color-text-secondary)",
        },
      }}
    >
      {buttonText}
    </Button>
  </Box>
);
};

export default BeginSurveyCard;
